<nb-card class="user-note-alert-card-container {{ type }} {{ customClass }}">
  <nb-card-body class="d-flex justify-content-between align-items-start">
    <div>
      <!-- Icon and user note title -->
      <div
        *ngIf="title"
        class="d-flex align-items-center justify-content-start"
      >
        <nb-icon [icon]="icon" pack="fci" class="alert-type-icon"></nb-icon>
        <p class="mb-0 weight-600">{{ title }}</p>
      </div>

      <!-- Description -->
      <p class="mt-1 mb-0 left-spacing" *ngIf="description">
        {{ description }}
      </p>

      <!-- Additional notes - will be displayed as points by default. Can turn off this mode by setting showNotesAsList=false-->
      <ul
        class="mt-1"
        *ngIf="additionalNotes?.length"
        [ngStyle]="{ 'padding-left': showNotesAsList ? '40px' : '24px' }"
      >
        <li
          *ngFor="let note of additionalNotes"
          class="list-item-description"
          [ngStyle]="{ 'list-style-type': showNotesAsList ? 'circle' : 'none' }"
        >
          {{ note }}
        </li>
      </ul>

      <!-- Custom content projection -->
      <div class="mt-1 left-spacing">
        <ng-content></ng-content>
      </div>

      <!-- Links -->
      <div
        *ngIf="links?.length > 0"
        class="mt-2 links-container"
        style="display: flex; flex-wrap: wrap"
      >
        <ng-container *ngFor="let link of links; let i = index">
          <a
            [href]="link?.url"
            [routerLink]="link?.routerLink"
            [nbTooltip]="link?.tooltip"
            [nbTooltipDisabled]="!link?.tooltip"
            (click)="onLinkClick(link, i)"
            class="d-flex justify-content-start align-items-center cursor-pointer mr-3"
            [ngStyle]="{
              'text-decoration': link?.url ? '' : 'none',
              'pointer-events': link?.disabled ? 'none' : '',
              'padding-left': true ? '24px' : '24px'
            }"
          >
            <span class="mr-1">{{ link?.label }}</span>
            <nb-icon [icon]="link?.icon" *ngIf="link?.icon"></nb-icon>
          </a>
        </ng-container>
      </div>
    </div>
    <div>
      <ng-content select="[actionButton]"></ng-content>
    </div>
  </nb-card-body>
</nb-card>
